import IPMModule from './IPMModule';
import Inventory from './Inventory';
import VendorManagement from './VendorManagement';
import GroupBooking from './GroupBooking';
import StaffFood from './StaffFood';
import PrintModule from './PrintModule';
import Housekeeping from './Housekeeping';
import PushNotificationManager, { NotificationBell } from './PushNotifications';
import LiveDashboard from './LiveDashboard';
import MealForecast from './MealForecast';
import BotanixAI from './BotanixAI';
import LeadAI from './LeadAI';
import RevenueAI from './RevenueAI';
import WeddingAI from './WeddingAI';
import KitchenAI from './KitchenAI';
import BMint from './BMint';
import GMDashboard from './GMDashboard';
import FrontOfficeDashboard from './FrontOfficeDashboard';
import RoomManagement from './RoomManagement';
import RoomPMS from './RoomPMS';
import RoomCalendar from './RoomCalendar';
import GuestPortal from './GuestPortal';
import NewDashboard from './NewDashboard';
import FoodMenu from './FoodMenu';
import SalesCRM from './SalesCRM';
import ProposalBuilder from './ProposalBuilder';
import PropertyConfig from './PropertyConfig';
import SalesDashboard from './SalesDashboard';
import SalesPerformance from './SalesPerformance';
import Notifications from './Notifications';
import Reports from './Reports'; 
import { useAuth } from './auth/AuthContext';
  import LoginPage from './auth/LoginPage';
  import UserManagement from './UserManagement';
import React, { useState, useEffect, useCallback } from 'react';
import BookingEngine from './BookingEngine';
import PricingManager from './PricingManager';
import DynamicPricing from './DynamicPricing';
import Accounts from './Accounts';
import InvoiceModule from './InvoiceModule';
import RefundManagement from './RefundManagement';
import GSTConfig from './GSTConfig';
import HR from './HR';
import Marketing from './Marketing';
import Horticulture from './Horticulture';
import Construction from './Construction';
import KitchenManagement from './KitchenManagement';
import SocialMediaIntegration from './SocialMediaIntegration';
import SessionLogs from './SessionLogs';
import MasterDelete from './MasterDelete';
// 
//  API ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
const BASE = `${process.env.REACT_APP_API_URL}/api`;
const api = {
  get: (p) => fetch(BASE + p).then(r => r.json()).catch(() => ({})),
  post: (p, b) => fetch(BASE + p, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b) }).then(r => r.json()).catch(() => ({})),
  patch: (p, b) => fetch(BASE + p, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b) }).then(r => r.json()).catch(() => ({})),
};

const inr = (n) => '₹' + Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });
const uid = (type) => {
  const year = new Date().getFullYear();
  const prefixes = {
    'Room Stay':'BTX-R', 'Day Outing':'BTX-D', 'Corporate':'BTX-C',
    'Wedding':'BTX-W', 'School Picnic':'BTX-S', 'MICE':'BTX-M',
    'Social Event':'BTX-E', 'Conference':'BTX-CF',
  };
  const prefix = prefixes[type] || 'BTX';
  const lastKey = `botanix_last_id_${prefix}`;
  const last = parseInt(localStorage.getItem(lastKey) || '1000');
  const next = last + 1;
  localStorage.setItem(lastKey, next);
  return `${prefix}-${year}-${next}`;
};
const todayStr = () => new Date().toISOString().slice(0, 10);
const fmtTime = (ts) => { try { return new Date(ts).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }); } catch { return '₹'; } };

//  TOKENS ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
const C = {
  sidebar: '#0A1628', sidebarBorder: 'rgba(30,58,95,.8)',
  sidebarActive: '#0F2040', sidebarHover: '#1E3A5F',
  accent: '#3AAF58', accentDark: '#2E8B47', accentLight: '#EAF7EE',
  bg: '#F3F6F3', surface: '#FFFFFF',
  border: '#E2E8E2', border2: '#CDD8CD',
  text: '#1A2E1E', text2: '#3D5E44', text3: '#7A9A80',
  amber: '#D4840F', amberBg: '#FEF6E7', amberBorder: '#F0D499',
  red: '#C83333', redBg: '#FDEAEA', redBorder: '#F0B8B8',
  blue: '#2563A8', blueBg: '#EAF1FB', blueBorder: '#B8D0F0',
  purple: '#6B48A8', purpleBg: '#F0EBFB', purpleBorder: '#C8B8F0',
  teal: '#1A7A7A', tealBg: '#E7F5F5', tealBorder: '#A8D8D8',
};

//  INJECT STYLES ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
const injectStyles = () => {
  if (document.getElementById('bx')) return;
  const s = document.createElement('style');
  s.id = 'bx';
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Plus+Jakarta+Sans:wght@700;800&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    html,body,#root{height:100%}
    body{background:${C.bg};color:${C.text};font-family:'Inter',sans-serif;font-size:14px}
    button,input,select,textarea{font-family:'Inter',sans-serif}
    ::-webkit-scrollbar{width:4px;height:4px}
    ::-webkit-scrollbar-thumb{background:${C.border2};border-radius:4px}
    .nav-item:hover{background:${C.sidebarHover}!important}
    .row-h:hover{background:#F7FAF7!important}
    .card-h{transition:box-shadow .18s,transform .18s}
    .card-h:hover{box-shadow:0 6px 24px rgba(0,0,0,.09)!important;transform:translateY(-1px)}
    .btn-t{transition:opacity .15s,transform .1s}
    .btn-t:hover{opacity:.87}
    .btn-t:active{transform:scale(.97)}
    input:focus,select:focus,textarea:focus{outline:none!important;border-color:${C.accent}!important;box-shadow:0 0 0 3px ${C.accentLight}}
    .sub-item:hover{background:rgba(255,255,255,.06)!important;color:#fff!important}
  `;
  document.head.appendChild(s);
};

//  ATOMS ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
const Card = ({ children, style = {}, className = '' }) => (
  <div className={className} style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,.05)', ...style }}>{children}</div>
);

const Chip = ({ children, color = C.text3, bg = C.border, border = C.border2, dot }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 99, fontSize: 11, fontWeight: 600, color, background: bg, border: `1px solid ${border}` }}>
    {dot && <span style={{ width: 6, height: 6, borderRadius: '50%', background: color, flexShrink: 0 }} />}
    {children}
  </span>
);

const STATUS_MAP = {
  'Confirmed':    [C.blue, C.blueBg, C.blueBorder],
  'Checked In':   [C.accent, C.accentLight, '#A8D8B8'],
  'Completed':    [C.text3, C.border, C.border2],
  'Vacant Clean': [C.accent, C.accentLight, '#A8D8B8'],
  'Occupied':     [C.blue, C.blueBg, C.blueBorder],
  'Vacant Dirty': [C.amber, C.amberBg, C.amberBorder],
  'Maintenance':  [C.red, C.redBg, C.redBorder],
  'Pending':      [C.amber, C.amberBg, C.amberBorder],
  'In Progress':  [C.blue, C.blueBg, C.blueBorder],
  'High':         [C.red, C.redBg, C.redBorder],
  'Medium':       [C.amber, C.amberBg, C.amberBorder],
  'Low':          [C.accent, C.accentLight, '#A8D8B8'],
  'Active':       [C.accent, C.accentLight, '#A8D8B8'],
  'OK':           [C.accent, C.accentLight, '#A8D8B8'],
  'Reorder':      [C.red, C.redBg, C.redBorder],
  'New':          [C.purple, C.purpleBg, C.purpleBorder],
  'Hot':          [C.red, C.redBg, C.redBorder],
  'Warm':         [C.amber, C.amberBg, C.amberBorder],
  'Cold':         [C.blue, C.blueBg, C.blueBorder],
  'Converted':    [C.accent, C.accentLight, '#A8D8B8'],
  'Lost':         [C.text3, C.border, C.border2],
  'Open':         [C.amber, C.amberBg, C.amberBorder],
  'Resolved':     [C.accent, C.accentLight, '#A8D8B8'],
  'Delayed':      [C.red, C.redBg, C.redBorder],
  'On Track':     [C.accent, C.accentLight, '#A8D8B8'],
  'Overdue':      [C.red, C.redBg, C.redBorder],
};
const SBadge = ({ s }) => { const [c, bg, b] = STATUS_MAP[s] || [C.text3, C.border, C.border2]; return <Chip color={c} bg={bg} border={b} dot>{s}</Chip>; };

const Btn = ({ children, onClick, variant = 'primary', style = {}, disabled, type = 'button' }) => {
  const v = { primary: { background: C.accent, color: '#fff', border: 'none' }, danger: { background: C.red, color: '#fff', border: 'none' }, ghost: { background: 'transparent', color: C.text2, border: `1px solid ${C.border2}` }, outline: { background: 'transparent', color: C.accent, border: `1px solid ${C.accent}` }, light: { background: C.accentLight, color: C.accent, border: 'none' } };
  return <button type={type} onClick={onClick} disabled={disabled} className="btn-t" style={{ ...v[variant], padding: '8px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1, display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap', ...style }}>{children}</button>;
};

const Inp = ({ label, value, onChange, type = 'text', opts, placeholder = '' }) => {
  const base = { width: '100%', padding: '9px 12px', background: C.bg, border: `1px solid ${C.border2}`, borderRadius: 8, color: C.text, fontSize: 13 };
  return (
    <div style={{ marginBottom: 13 }}>
      {label && <div style={{ fontSize: 11, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 5 }}>{label}</div>}
      {opts ? <select style={base} value={value} onChange={e => onChange(e.target.value)}>{opts.map(o => <option style={{background:'#0F2040',color:'#F0F2FF'}} key={o}>{o}</option>)}</select>
             : <input type={type} style={base} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} />}
    </div>
  );
};

const Modal = ({ title, onClose, children, width = '480px' }) => (
  <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
    <Card style={{ width, maxWidth: '100%', maxHeight: '90vh', overflow: 'auto', padding: 28, boxShadow: '0 24px 64px rgba(0,0,0,.18)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
        <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 18, fontWeight: 800, color: C.text }}>{title}</div>
        <button onClick={onClose} style={{ background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8, width: 32, height: 32, cursor: 'pointer', color: C.text2, fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>₹₹</button>
      </div>
      {children}
    </Card>
  </div>
);

const Th = ({ c }) => <th style={{ padding: '11px 14px', fontSize: 11, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.06em', textAlign: 'left', background: '#F5F8F5', borderBottom: `1px solid ${C.border}`, whiteSpace: 'nowrap' }}>{c}</th>;
const Td = ({ children, style = {} }) => <td style={{ padding: '12px 14px', fontSize: 13, borderBottom: `1px solid ${C.border}`, verticalAlign: 'middle', ...style }}>{children}</td>;
const Empty = ({ icon, msg }) => <div style={{ padding: '56px 20px', textAlign: 'center' }}><div style={{ fontSize: 34, marginBottom: 10 }}>{icon}</div><div style={{ color: C.text3, fontSize: 14 }}>{msg}</div></div>;
const Bar = ({ pct, color = C.accent }) => <div style={{ height: 6, background: C.border, borderRadius: 99, overflow: 'hidden' }}><div style={{ height: 6, width: `${Math.min(pct, 100)}%`, background: color, borderRadius: 99, transition: 'width .4s' }} /></div>;
const AlertBar = ({ children, tone = 'amber', onClose }) => {
  const t = { amber: [C.amberBg, C.amberBorder, C.amber], red: [C.redBg, C.redBorder, C.red], green: [C.accentLight, '#A8D8B8', C.accent] };
  const [bg, border, color] = t[tone] || t.amber;
  return <div style={{ background: bg, border: `1px solid ${border}`, borderRadius: 10, padding: '11px 16px', marginBottom: 9, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}><span style={{ fontSize: 13, color, fontWeight: 500 }}>{children}</span>{onClose && <button onClick={onClose} style={{ background: 'none', border: 'none', color, cursor: 'pointer', opacity: .7, fontSize: 16, padding: '0 4px' }}>₹₹</button>}</div>;
};

//  STAT CARD ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
const Stat = ({ label, value, sub, icon, iconBg = C.accentLight, iconColor = C.accent, valueColor = C.text, onClick }) => (
  <Card className="card-h" onClick={onClick} style={{ padding: 20, cursor: onClick ? 'pointer' : 'default', transition: 'all .15s', transform: 'scale(1)', boxShadow: onClick ? '0 2px 8px rgba(0,0,0,.08)' : 'none' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.06em' }}>{label}</div>
      <div style={{ width: 36, height: 36, borderRadius: 10, background: iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>{icon}</div>
    </div>
    <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 26, fontWeight: 800, color: valueColor, letterSpacing: '-.02em' }}>{value}</div>
    {sub && <div style={{ fontSize: 12, color: C.text3, marginTop: 3 }}>{sub}</div>}
  </Card>
);

//  TOP BAR ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
const TopBar = ({ title, subtitle, action, alertCount = 0 }) => (
  <div style={{ background: C.surface, borderBottom: `1px solid ${C.border}`, padding: '0 28px', position: 'sticky', top: 0, zIndex: 50 }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 62 }}>
       <div>
        {subtitle && <div style={{ fontSize: 11, color: C.text3, fontWeight: 500, marginBottom: 1 }}>{subtitle}</div>}
        <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 20, fontWeight: 800, color: C.text, letterSpacing: '-.02em' }}>{title}</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <NotificationBell/>
{alertCount > 0 && (
          <div style={{ position: 'relative', cursor: 'pointer' }}>
            <div style={{ fontSize: 22 }}>₹₹₹</div>
            <span style={{ position: 'absolute', top: -4, right: -4, background: C.red, color: '#fff', fontSize: 9, fontWeight: 700, width: 16, height: 16, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{alertCount}</span>
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 12px', background: C.bg, borderRadius: 10, border: `1px solid ${C.border}` }}>
          <div style={{ width: 30, height: 30, borderRadius: '50%', background: C.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: '#fff' }}>
  ₹₹₹
</div>
<div style={{ fontSize: 12, fontWeight: 600, color: C.text, lineHeight: 1.2 }}>
  <div style={{fontWeight:700}}>Botanix ERP</div>
  </div>
</div>
      </div>
    </div>
  </div>
);
//  NAVIGATION DATA ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
const NAV = [
  { section: 'OVERVIEW', items: [
    { id: 'dashboard',         label: 'Dashboard',            icon: 'O' },
    { id: 'botanix_ai',        label: 'Botanix AI',           icon: 'AI' },
    { id: 'lead_ai',           label: 'Lead Intelligence',    icon: '🎯' },
    { id: 'revenue_ai',        label: 'Revenue AI',           icon: '💰' },
    { id: 'wedding_ai',        label: 'Wedding AI',           icon: '💍' },
    { id: 'kitchen_ai',        label: 'Kitchen AI',           icon: '🍽️' },
    { id: 'bmint',             label: 'Market Intelligence',  icon: '🌐' },
    { id: 'gm_dashboard',      label: 'GM Dashboard',         icon: 'GM' },
    { id: 'notifications',     label: 'Email & WhatsApp',     icon: 'E' },
  ]},
  { section: 'SALES & CRM', items: [
    { id: 'my_sales',          label: 'My Sales',             icon: 'S' },
    { id: 'sales_performance', label: 'Sales Performance',    icon: 'P' },
    { id: 'guest_portal',      label: 'Guest Portal',         icon: 'G' },
    { id: 'crm',               label: 'Sales CRM',            icon: 'C' },
    { id: 'proposals',         label: 'Proposals',            icon: 'PR' },
    { id: 'social_media',      label: 'Social Media & Leads', icon: 'SM' },
    { id: 'marketing',         label: 'Marketing',            icon: 'MK' },
  ]},
  { section: 'OPERATIONS', items: [
    { id: 'front_office',      label: 'Front Office',         icon: 'FO' },
    { id: 'bookings',          label: 'Bookings',             icon: 'BK' },
    { id: 'rooms',             label: 'Rooms / PMS',          icon: 'RM' },
    { id: 'room_management',   label: 'Room Management',      icon: 'RG' },
    { id: 'room_calendar',     label: 'Room Calendar PMS',    icon: 'RC' },
    { id: 'calendar',          label: 'Room Calendar',        icon: 'CA' },
    { id: 'events',            label: 'Events & Weddings',    icon: 'EV' },
    { id: 'activities',        label: 'Activities & Slots',   icon: 'AC' },
    { id: 'housekeeping',      label: 'Housekeeping',         icon: 'HK' },
    { id: 'meal_forecast',     label: 'Meal Forecast',        icon: 'MF' },
  ]},
  { section: 'F&B & PROJECTS', items: [
    { id: 'food_menu',         label: 'Food Menu & Orders',   icon: 'FM' },
    { id: 'kitchen',           label: 'Kitchen Management',   icon: 'KM' },
    { id: 'inventory',         label: 'Inventory',            icon: 'IN' },
    { id: 'vendors',           label: 'Vendor Management',    icon: 'VN' },
    { id: 'horticulture',      label: 'Horticulture',         icon: 'HT' },
{ id: 'ipm', label: 'IPM & Disease Predictor', icon: 'IP' },
    { id: 'construction',      label: 'Construction',         icon: 'CN' },
  ]},
  { section: 'ADMIN', items: [
    { id: 'accounts',          label: 'Accounts',             icon: 'AC' },
    { id: 'invoices',          label: 'Invoice Management',   icon: 'IV' },
    { id: 'refunds',           label: 'Refund Management',    icon: 'RF' },
    { id: 'hr',                label: 'HR',                   icon: 'HR' },
    { id: 'reports',           label: 'Reports',              icon: 'RP' },
    { id: 'dynamic_pricing',   label: 'Dynamic Pricing',      icon: 'DP' },
    { id: 'gst',               label: 'GST Configuration',    icon: 'GS' },
    { id: 'sales_admin',       label: 'Sales CRM Admin',      icon: 'SC' },
    { id: 'user_management',   label: 'User Management',      icon: 'UM' },
    { id: 'session_logs',      label: 'Session Logs',         icon: 'SL' },
    { id: 'property_config',   label: 'Property Config',      icon: 'PC' },
    { id: 'settings',          label: 'Settings',             icon: 'ST' },
  ]},
];

// ── ROLE-BASED NAV PERMISSIONS ─────────────────────────────────────────────
const NAV_PERMISSIONS = {
  SUPER_ADMIN:    null, // null = show everything
  ADMIN:          null,
  RESORT_GM:      null, // GM sees everything
  FRONT_OFFICE:   ['botanix_ai','gm_dashboard','front_office','bookings','rooms','room_management','room_calendar','calendar','events','activities','housekeeping','meal_forecast','notifications','crm','guest_portal'],
  MARKETING:      ['botanix_ai','my_sales','sales_performance','crm','social_media','marketing','guest_portal','notifications','bookings','front_office','events','room_calendar','gm_dashboard'],
  SALES_DIRECTOR: ['botanix_ai','my_sales','sales_performance','crm','social_media','marketing','guest_portal','notifications','bookings','front_office','events','room_calendar','gm_dashboard','reports','accounts'],
  KITCHEN:        ['botanix_ai','kitchen','food_menu','inventory','meal_forecast','housekeeping'],
  HOUSEKEEPING:   ['botanix_ai','housekeeping','room_management','activities'],
  ACCOUNTS:       ['botanix_ai','accounts','reports','gst','dynamic_pricing','bookings','front_office'],
  HR:             ['botanix_ai','hr','reports','user_management'],
  HORTICULTURE:   ['botanix_ai','horticulture','ipm'],
  CONSTRUCTION:   ['botanix_ai','construction'],
  SECURITY:       ['botanix_ai','housekeeping'],
};

function getFilteredNav(roleKey) {
  const allowed = NAV_PERMISSIONS[roleKey];
  if (!allowed) return NAV; // show all for admin/GM
  return NAV.map(section => ({
    ...section,
    items: section.items.filter(item => allowed.includes(item.id))
  })).filter(section => section.items.length > 0);
}

//  SIDEBAR ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
function Sidebar({ tab, setTab, alertCount, user, logout }) {
  const [openMenus, setOpenMenus] = useState({ crm: true });
  const { hasAccess } = useAuth();
  const canSee = (id) => {
    if (!user) return false;
    const roleKey = user.roleKey || user.role;
    // Super admin and GM see everything
    if (roleKey === "SUPER_ADMIN" || roleKey === "Super Admin" || roleKey === "ADMIN" || roleKey === "Admin" || roleKey === "RESORT_GM") return true;
    // Role-based nav permissions
    const roleNavMap = {
      FRONT_OFFICE:   ['botanix_ai','gm_dashboard','front_office','bookings','rooms','room_management','room_calendar','calendar','events','activities','housekeeping','meal_forecast','notifications','crm','guest_portal','my_sales','refunds','invoices'],
      MARKETING:      ['botanix_ai','lead_ai','wedding_ai','bmint','my_sales','sales_performance','crm','proposals','social_media','marketing','guest_portal','notifications','bookings','front_office','events','room_calendar','gm_dashboard','rooms','room_management'],
      SALES_DIRECTOR: ['botanix_ai','lead_ai','wedding_ai','revenue_ai','bmint','my_sales','sales_performance','crm','proposals','social_media','marketing','guest_portal','notifications','bookings','front_office','events','room_calendar','gm_dashboard','rooms','room_management','reports','accounts','sales_admin'],
      KITCHEN:        ['botanix_ai','kitchen','food_menu','inventory','meal_forecast'],
      HOUSEKEEPING:   ['botanix_ai','housekeeping','room_management','activities'],
      ACCOUNTS:       ['botanix_ai','accounts','reports','gst','dynamic_pricing','bookings','front_office'],
      HR:             ['botanix_ai','hr','reports','user_management'],
      HORTICULTURE:   ['botanix_ai','horticulture','ipm'],
      CONSTRUCTION:   ['botanix_ai','construction'],
      SECURITY:       ['botanix_ai','housekeeping'],
    };
    const allowed = roleNavMap[roleKey];
    if (!allowed) return true; // unknown role - show all
    return allowed.includes(id);
  };
  const filterItems = (items) => (items || []).filter(item => canSee(item.id));
  const toggleMenu = (id) => setOpenMenus(p => ({ ...p, [id]: !p[id] }));

  const isActive = (item) => {
    if (tab === item.id) return true;
    if (item.children) return item.children.some(c => c.id === tab);
    return false;
  };

  return (
    <aside style={{ width: 232, minWidth: 232, background: C.sidebar, display: 'flex', flexDirection: 'column', height: '100vh', position: 'sticky', top: 0, overflowY: 'auto' }}>
      {/* Logo */}
      <div style={{ padding: '20px 18px 16px', borderBottom: `1px solid ${C.sidebarBorder}`, flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src='https://botanix.in/wp-content/uploads/2025/12/Botanix-Nature-Resort-Logo.webp' alt='Botanix' style={{ width:34, height:34, borderRadius:10, objectFit:'contain', background:'#fff', padding:2, flexShrink:0 }} onError={e=>{e.target.style.display='none'}} />
          <div>
            <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 17, fontWeight: 800, color: '#fff', letterSpacing: '-.01em' }}>Botanix</div>
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,.4)', marginTop: 1 }}>ERP Platform</div>
          </div>
        </div>
      </div>

      {/* User */}
      <div style={{ padding: '13px 16px', borderBottom: `1px solid ${C.sidebarBorder}`, display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
        <div style={{ width: 34, height: 34, borderRadius: '50%', background: 'linear-gradient(135deg,#3AAF58,#2E8B47)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#fff', flexShrink: 0 }}>₹₹₹</div>
        <div><div style={{ fontSize: 13, fontWeight: 600, color: '#fff' }}>{user?.name||"User"}</div><div style={{ fontSize: 10, color: 'rgba(255,255,255,.4)' }}>ERP Platform</div></div><button onClick={logout} style={{width:'100%',marginTop:6,padding:'6px',background:'rgba(200,51,51,.15)',border:'1px solid rgba(200,51,51,.3)',borderRadius:7,color:'#E05050',fontSize:11,fontWeight:600,cursor:'pointer'}}>Logout</button>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: '8px 8px', overflowY: 'auto' }}>
        {NAV.filter(s => s.items && filterItems(s.items).length > 0).map(section => (
          <div key={section.section}>
            <div style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,.28)', textTransform: 'uppercase', letterSpacing: '.1em', padding: '14px 10px 6px' }}>{section.section}</div>
            {filterItems(section.items).map(item => {
              const active = isActive(item);
              const open = openMenus[item.id];
              return (
                <div key={item.id}>
                  <button className="nav-item"
                    onClick={() => { if (item.children) toggleMenu(item.id); else setTab(item.id); }}
                    style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 9, padding: '9px 12px', borderRadius: 8, border: 'none', cursor: 'pointer', background: active && !item.children ? C.sidebarActive : 'transparent', color: active ? '#fff' : 'rgba(255,255,255,.55)', fontSize: 13, fontWeight: active ? 600 : 500, marginBottom: 1, textAlign: 'left' }}>
                    <span style={{ fontSize: 14 }}>{item.icon}</span>
                    <span style={{ flex: 1 }}>{item.label}</span>
                    {item.id === 'dashboard' && alertCount > 0 && <span style={{ background: C.red, color: '#fff', fontSize: 10, fontWeight: 700, padding: '1px 6px', borderRadius: 99 }}>{alertCount}</span>}
                    {item.children && <span style={{ fontSize: 10, color: 'rgba(255,255,255,.3)' }}>{open ? '₹₹' : '₹'}</span>}
                  </button>
                  {item.children && open && (
                    <div style={{ paddingLeft: 10, marginBottom: 4 }}>
                      {item.children.map(child => (
                        <button key={child.id} className="sub-item"
                          onClick={() => setTab(child.id)}
                          style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 8, padding: '7px 12px', borderRadius: 7, border: 'none', cursor: 'pointer', background: tab === child.id ? 'rgba(58,175,88,.25)' : 'transparent', color: tab === child.id ? '#fff' : 'rgba(255,255,255,.42)', fontSize: 12, fontWeight: tab === child.id ? 600 : 400, marginBottom: 1, textAlign: 'left', transition: 'all .13s' }}>
                          <span style={{ width: 5, height: 5, borderRadius: '50%', background: tab === child.id ? C.accent : 'rgba(255,255,255,.25)', flexShrink: 0 }} />
                          {child.label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </nav>

      <div style={{ padding: '12px 16px', borderTop: `1px solid ${C.sidebarBorder}`, display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        <span style={{ width: 7, height: 7, borderRadius: '50%', background: C.accent, flexShrink: 0 }} />
        <span style={{ fontSize: 11, color: 'rgba(255,255,255,.3)' }}>PostgreSQL connected</span>
      </div>
    </aside>
  );
}

//  DASHBOARD ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
// Sample alerts data
const SYSTEM_ALERTS = [
  { id: 'a1', tone: 'red',   icon: '', msg: 'New lead "Priya Events" not contacted ₹ 22 min elapsed (>15 min SLA)' },
  { id: 'a2', tone: 'amber', icon: '', msg: 'Wedding enquiry from "Kapoor Family" pending 28 hours ₹ needs follow-up' },
  { id: 'a3', tone: 'amber', icon: '', msg: 'Room 103 marked Dirty for 2h 15min ₹ housekeeping not assigned' },
  { id: 'a4', tone: 'red',   icon: '', msg: 'Paneer stock below reorder level ₹ 40kg remaining, reorder at 60kg' },
  { id: 'a5', tone: 'amber', icon: '', msg: 'Rose garden spray due today ₹ last spray was 14 days ago' },
  { id: 'a6', tone: 'red',   icon: '', msg: 'Construction milestone "Cottage A foundation" delayed by 3 days' },
  { id: 'a7', tone: 'amber', icon: '', msg: 'Contractor bill from M/s Suresh Works ₹₹1,45,000 pending approval' },
  { id: 'a8', tone: 'red',   icon: '', msg: 'Guest complaint by Mr. Arora (Room 204) unresolved for 4 hours' },
  { id: 'a9', tone: 'red',   icon: '', msg: 'Payment of ₹₹4,50,000 from ABC Technologies overdue by 5 days' },
  { id: 'a10', tone: 'amber', icon: '', msg: '2 staff absent without approval today ₹ Ramesh (Kitchen), Suman (HK)' },
];

function Dashboard({ setTab }) {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState([]);
  const dismiss = (id) => setDismissed(p => [...p, id]);
  const visibleAlerts = SYSTEM_ALERTS.filter(a => !dismissed.includes(a.id));

  useEffect(() => {
    api.get('/dashboard').then(setData).catch(() =>
      setData({ rooms: [], todayBookings: { revenue: 0, total: 0 }, lowStockCount: 0, pendingHousekeeping: 0, todayEvents: [] }));
  }, []);

  const occupied = data ? parseInt(data.rooms?.find(r => r.status === 'Occupied')?.count || 0) : 0;
  const totalRooms = data ? (data.rooms || []).reduce((s, r) => s + parseInt(r.count || 0), 0) : 0;
  const revenue = data ? parseFloat(data.todayBookings?.revenue || 0) : 0;
  const bookingsCount = data ? parseInt(data.todayBookings?.total || 0) : 0;
  const lowStock = data ? parseInt(data.lowStockCount || 0) : 0;

  return (
    <>
      <TopBar title="Botanix Command Centre" subtitle={new Date().toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })} alertCount={visibleAlerts.length} />
      <div style={{ padding: '24px 28px' }}>
        {/* Alerts */}
        {visibleAlerts.length > 0 && (
          <div style={{ marginBottom: 22 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.06em', display: 'flex', alignItems: 'center', gap: 8 }}>
                Active Alerts
                <span style={{ background: C.red, color: '#fff', fontSize: 10, fontWeight: 700, padding: '1px 7px', borderRadius: 99 }}>{visibleAlerts.length}</span>
              </div>
              <button onClick={() => setDismissed(SYSTEM_ALERTS.map(a => a.id))} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, color: C.text3, textDecoration: 'underline' }}>Dismiss all</button>
            </div>
            <div style={{ maxHeight: 260, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 0 }}>
              {visibleAlerts.map(a => <AlertBar key={a.id} tone={a.tone} onClose={() => dismiss(a.id)}>{a.icon} {a.msg}</AlertBar>)}
            </div>
          </div>
        )}

        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 13, marginBottom: 22 }}>
          <Stat label="Room Occupancy"   value={`${occupied}/${totalRooms}`} sub={`${Math.round((occupied/Math.max(totalRooms,1))*100)}% occupied`} icon="₹₹₹" iconBg={C.blueBg} valueColor={C.blue} onClick={()=>setTab('rooms')} />
<Stat label="Today's Revenue"  value={inr(revenue)}   sub="All bookings"       icon="₹₹"  valueColor={C.accent}                        onClick={()=>setTab('accounts')} />
<Stat label="Today's Bookings" value={bookingsCount}   sub="Confirmed + active" icon="₹₹₹₹" iconBg={C.purpleBg} valueColor={C.purple}    onClick={()=>setTab('bookings')} />
<Stat label="Low Stock Items"  value={lowStock}        sub="Need reorder"       icon="₹₹"  iconBg={C.amberBg}  valueColor={C.amber}     onClick={()=>setTab('inventory')} />
<Stat label="Open Complaints"  value={0}           sub="Unresolved"     icon="₹₹₹" iconBg={C.redBg}   valueColor={C.red}   onClick={()=>setTab('housekeeping')} />
<Stat label="Payments Overdue" value={inr(0)}       sub="From clients"   icon="₹₹₹₹" iconBg={C.amberBg} valueColor={C.amber} onClick={()=>setTab('accounts')} />
        </div>

        {/* Two column section */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: 16, marginBottom: 16 }}>
          {/* Quick Nav */}
          <Card style={{ padding: 22 }}>
            <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 15, fontWeight: 800, color: C.text, marginBottom: 16 }}>Quick Navigation</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              {[
                ['₹₹₹', 'Leads & CRM', 'crm'],
                ['₹₹₹₹', 'Bookings', 'bookings'],
                ['₹₹₹', 'Rooms / PMS', 'rooms'],
                ['₹₹₹₹₹', 'Events & Weddings', 'events'],
                ['₹₹₹', 'Kitchen & Inventory', 'inventory'],
                ['₹₹₹', 'Horticulture', 'horticulture'],
                ['₹₹₹', 'Construction', 'construction'],
                ['₹₹₹₹', 'Accounts', 'accounts'],
                ['₹₹₹', 'HR', 'hr'],
                ['₹₹₹₹', 'Marketing', 'marketing'],
                ['₹₹₹₹', 'Reports', 'reports'],
                ['₹', 'Settings', 'settings'],
              ].map(([icon, label, id]) => (
                <button key={id} onClick={() => setTab(id)}
                  style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 12px', borderRadius: 9, border: `1px solid ${C.border}`, background: C.bg, cursor: 'pointer', textAlign: 'left', fontSize: 12, fontWeight: 500, color: C.text2, transition: 'all .13s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = C.accent; e.currentTarget.style.background = C.accentLight; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.background = C.bg; }}>
                  <span style={{ fontSize: 15 }}>{icon}</span>{label}
                </button>
              ))}
            </div>
          </Card>

          {/* Today's events */}
          <Card style={{ padding: 22 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 15, fontWeight: 800, color: C.text }}>Today's Events & Bookings</div>
              <Btn variant="light" style={{ padding: '5px 12px', fontSize: 12 }} onClick={() => setTab('bookings')}>View All ₹₹₹</Btn>
            </div>
            {!data || !data.todayEvents || data.todayEvents.length === 0 ? <Empty icon="₹₹₹₹" msg="No events today" /> : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr><Th c="Code" /><Th c="Group / Guest" /><Th c="Type" /><Th c="Pax" /></tr></thead>
                <tbody>
                  {data.todayEvents.map((e, i) => (
                    <tr key={i} className="row-h" style={{ cursor: 'pointer' }} onClick={() => setTab('bookings')}>
                      <Td><span style={{ fontFamily: 'monospace', fontSize: 11, background: C.bg, padding: '2px 6px', borderRadius: 4, color: C.text3 }}>{e.booking_code}</span></Td>
                      <Td><span style={{ fontWeight: 600 }}>{e.company_name || e.full_name || '₹'}</span></Td>
                      <Td><SBadge s="Confirmed" /></Td>
                      <Td><span style={{ fontWeight: 700, color: C.accent }}>{e.pax_count}</span></Td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card>
        </div>

        {/* Department status */}
        <Card style={{ padding: 22 }}>
          <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 15, fontWeight: 800, color: C.text, marginBottom: 16 }}>Department Status Today</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 12 }}>
            {[
              ['Front Office', 'OK', C.accent, C.accentLight, '₹₹'],
              ['Kitchen', 'Attention', C.amber, C.amberBg, '₹₹₹₹'],
              ['Housekeeping', 'Busy', C.amber, C.amberBg, '₹₹₹'],
              ['Activities', 'OK', C.accent, C.accentLight, '₹₹'],
              ['Horticulture', 'Spray Due', C.amber, C.amberBg, '₹₹₹'],
              ['Accounts', 'Overdue', C.red, C.redBg, '₹₹₹₹'],
              ['HR', 'Absent', C.red, C.redBg, '₹₹₹'],
              ['Sales', '3 Hot Leads', C.accent, C.accentLight, '₹₹₹'],
            ].map(([dept, status, color, bg, icon]) => (
              <div key={dept} style={{ padding: '12px 14px', background: bg, borderRadius: 10, border: `1px solid ${color}22` }}>
                <div style={{ fontSize: 18, marginBottom: 4 }}>{icon}</div>
                <div style={{ fontSize: 12, fontWeight: 700, color: C.text, marginBottom: 2 }}>{dept}</div>
                <div style={{ fontSize: 11, fontWeight: 600, color }}>{status}</div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </>
  );
}

//  CRM (GENERIC SUB-PAGE HANDLER) ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
const LEADS_SAMPLE = [
  { id: 1, name: 'Priya Mehta Events', source: 'Instagram', type: 'Wedding', date: todayStr(), status: 'New', value: 250000, phone: '9820001001', followup: todayStr() },
  { id: 2, name: 'XYZ Corp HR', source: 'Website', type: 'Corporate Outing', date: todayStr(), status: 'Warm', value: 185000, phone: '9820001002', followup: todayStr() },
  { id: 3, name: 'Kapoor Family', source: 'WhatsApp', type: 'Wedding', date: todayStr(), status: 'Hot', value: 1200000, phone: '9820001003', followup: todayStr() },
  { id: 4, name: 'Green Valley School', source: 'Phone', type: 'School Picnic', date: todayStr(), status: 'Warm', value: 95000, phone: '9820001004', followup: todayStr() },
  { id: 5, name: 'Sharma & Co', source: 'OTA', type: 'Room Stay', date: todayStr(), status: 'Cold', value: 18000, phone: '9820001005', followup: todayStr() },
  { id: 6, name: 'ABC Technologies', source: 'Corporate', type: 'Corporate Outing', date: todayStr(), status: 'Converted', value: 700000, phone: '9820001006', followup: todayStr() },
  { id: 7, name: 'Singh Wedding', source: 'Referral', type: 'Wedding', date: todayStr(), status: 'Lost', value: 450000, phone: '9820001007', followup: todayStr() },
];

const CRM_PAGE_META = {
  crm_social:    { title: 'Social Media Leads', filter: l => l.source === 'Instagram' },
  crm_website:   { title: 'Website Leads', filter: l => l.source === 'Website' },
  crm_whatsapp:  { title: 'WhatsApp Leads', filter: l => l.source === 'WhatsApp' },
  crm_ota:       { title: 'OTA Leads', filter: l => l.source === 'OTA' },
  crm_corporate: { title: 'Corporate Leads', filter: l => l.type === 'Corporate Outing' },
  crm_wedding:   { title: 'Wedding Leads', filter: l => l.type === 'Wedding' },
  crm:           { title: 'All Leads & CRM', filter: () => true },
};

function CRMPage({ tab }) {
  const [leads, setLeads] = useState(LEADS_SAMPLE);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: '', source: 'Instagram', type: 'Wedding', phone: '', value: '', status: 'New', followup: todayStr() });
  const f = (k) => (v) => setForm(p => ({ ...p, [k]: v }));

  const meta = CRM_PAGE_META[tab] || CRM_PAGE_META['crm'];
  const filtered = leads.filter(meta.filter);
  const total = filtered.reduce((s, l) => s + l.value, 0);
  const hotCount = filtered.filter(l => l.status === 'Hot').length;
  const converted = filtered.filter(l => l.status === 'Converted').length;

  const addLead = () => {
    setLeads(p => [...p, { id: Date.now(), ...form, value: parseInt(form.value) || 0, date: todayStr() }]);
    setShowModal(false);
    setForm({ name: '', source: 'Instagram', type: 'Wedding', phone: '', value: '', status: 'New', followup: todayStr() });
  };

  if (tab === 'crm_calendar') return (
    <>
      <TopBar title="Lead Follow-up Calendar" subtitle="Sales & CRM" alertCount={0} />
      <div style={{ padding: '24px 28px' }}>
        <AlertBar tone="amber">₹₹₹₹ You have {leads.filter(l => l.followup === todayStr() && !['Converted','Lost'].includes(l.status)).length} follow-ups due today.</AlertBar>
        <Card style={{ padding: 22 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><Th c="Lead" /><Th c="Type" /><Th c="Status" /><Th c="Follow-up Date" /><Th c="Phone" /><Th c="Value" /></tr></thead>
            <tbody>
              {leads.filter(l => !['Converted','Lost'].includes(l.status)).map(l => (
                <tr key={l.id} className="row-h">
                  <Td><span style={{ fontWeight: 600 }}>{l.name}</span></Td>
                  <Td>{l.type}</Td>
                  <Td><SBadge s={l.status} /></Td>
                  <Td style={{ color: l.followup === todayStr() ? C.red : C.text3 }}>{l.followup} {l.followup === todayStr() && '₹₹ Today'}</Td>
                  <Td style={{ color: C.text3 }}>{l.phone}</Td>
                  <Td><span style={{ fontWeight: 600 }}>{inr(l.value)}</span></Td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>
    </>
  );

  if (tab === 'crm_pipeline') return (
    <>
      <TopBar title="Sales Pipeline" subtitle="Sales & CRM" alertCount={0} />
      <div style={{ padding: '24px 28px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12 }}>
          {['New','Warm','Hot','Converted','Lost'].map(stage => {
            const stageLeads = leads.filter(l => l.status === stage);
            const stageVal = stageLeads.reduce((s, l) => s + l.value, 0);
            return (
              <div key={stage}>
                <div style={{ fontWeight: 700, fontSize: 12, color: C.text2, marginBottom: 10, textTransform: 'uppercase', letterSpacing: '.05em' }}>{stage} <span style={{ fontWeight: 800, color: STATUS_MAP[stage]?.[0] || C.text }}>({stageLeads.length})</span></div>
                <div style={{ fontSize: 12, color: C.text3, marginBottom: 12 }}>{inr(stageVal)}</div>
                {stageLeads.map(l => (
                  <Card key={l.id} style={{ padding: 12, marginBottom: 8 }}>
                    <div style={{ fontWeight: 600, fontSize: 12, marginBottom: 4 }}>{l.name}</div>
                    <div style={{ fontSize: 11, color: C.text3 }}>{l.type}</div>
                    <div style={{ fontSize: 11, fontWeight: 600, color: C.accent, marginTop: 4 }}>{inr(l.value)}</div>
                  </Card>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );

  if (tab === 'crm_synopsis') return (
    <>
      <TopBar title="CRM Synopsis" subtitle="Sales & CRM" alertCount={0} />
      <div style={{ padding: '24px 28px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 22 }}>
          <Stat label="Total Leads" value={leads.length} icon="₹₹₹" />
          <Stat label="Hot Leads" value={leads.filter(l => l.status === 'Hot').length} icon="₹₹₹" iconBg={C.redBg} iconColor={C.red} valueColor={C.red} />
          <Stat label="Converted" value={leads.filter(l => l.status === 'Converted').length} icon="₹₹" valueColor={C.accent} />
          <Stat label="Pipeline Value" value={inr(leads.filter(l => !['Lost','Converted'].includes(l.status)).reduce((s, l) => s + l.value, 0))} icon="₹₹" valueColor={C.accent} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <Card style={{ padding: 20 }}>
            <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 800, fontSize: 15, marginBottom: 16 }}>Leads by Source</div>
            {['Instagram','Website','WhatsApp','OTA','Phone','Corporate','Referral'].map(src => {
              const cnt = leads.filter(l => l.source === src).length;
              if (!cnt) return null;
              return (
                <div key={src} style={{ marginBottom: 12 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
                    <span style={{ fontSize: 13 }}>{src}</span>
                    <span style={{ fontSize: 13, fontWeight: 600 }}>{cnt}</span>
                  </div>
                  <Bar pct={(cnt / leads.length) * 100} />
                </div>
              );
            })}
          </Card>
          <Card style={{ padding: 20 }}>
            <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 800, fontSize: 15, marginBottom: 16 }}>Leads by Type</div>
            {['Wedding','Corporate Outing','Room Stay','School Picnic'].map(type => {
              const cnt = leads.filter(l => l.type === type).length;
              if (!cnt) return null;
              return (
                <div key={type} style={{ marginBottom: 12 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
                    <span style={{ fontSize: 13 }}>{type}</span>
                    <span style={{ fontSize: 13, fontWeight: 600 }}>{cnt}</span>
                  </div>
                  <Bar pct={(cnt / leads.length) * 100} />
                </div>
              );
            })}
          </Card>
        </div>
      </div>
    </>
  );

  if (tab === 'crm_conversion') return (
    <>
      <TopBar title="Conversion Report" subtitle="Sales & CRM" alertCount={0} />
      <div style={{ padding: '24px 28px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 22 }}>
          <Stat label="Total Leads" value={leads.length} icon="₹₹₹" />
          <Stat label="Converted" value={leads.filter(l => l.status === 'Converted').length} icon="₹₹" valueColor={C.accent} />
          <Stat label="Conversion Rate" value={`${Math.round((leads.filter(l => l.status === 'Converted').length / leads.length) * 100)}%`} icon="₹₹₹₹" valueColor={C.accent} />
          <Stat label="Revenue Converted" value={inr(leads.filter(l => l.status === 'Converted').reduce((s, l) => s + l.value, 0))} icon="₹₹" valueColor={C.accent} />
        </div>
        <Card style={{ padding: 22 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><Th c="Lead" /><Th c="Type" /><Th c="Source" /><Th c="Value" /><Th c="Status" /></tr></thead>
            <tbody>
              {leads.map(l => (
                <tr key={l.id} className="row-h">
                  <Td><span style={{ fontWeight: 600 }}>{l.name}</span></Td>
                  <Td style={{ color: C.text3 }}>{l.type}</Td>
                  <Td style={{ color: C.text3 }}>{l.source}</Td>
                  <Td><span style={{ fontWeight: 600 }}>{inr(l.value)}</span></Td>
                  <Td><SBadge s={l.status} /></Td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>
    </>
  );

  if (tab === 'crm_lost') return (
    <>
      <TopBar title="Lost Lead Analysis" subtitle="Sales & CRM" alertCount={0} />
      <div style={{ padding: '24px 28px' }}>
        <AlertBar tone="red">₹₹₹₹ {leads.filter(l => l.status === 'Lost').length} leads lost this month. Total lost value: {inr(leads.filter(l => l.status === 'Lost').reduce((s, l) => s + l.value, 0))}</AlertBar>
        <Card style={{ padding: 22 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><Th c="Lead" /><Th c="Type" /><Th c="Source" /><Th c="Lost Value" /><Th c="Phone" /></tr></thead>
            <tbody>
              {leads.filter(l => l.status === 'Lost').map(l => (
                <tr key={l.id} className="row-h">
                  <Td><span style={{ fontWeight: 600 }}>{l.name}</span></Td>
                  <Td style={{ color: C.text3 }}>{l.type}</Td>
                  <Td style={{ color: C.text3 }}>{l.source}</Td>
                  <Td><span style={{ fontWeight: 600, color: C.red }}>{inr(l.value)}</span></Td>
                  <Td style={{ color: C.text3 }}>{l.phone}</Td>
                </tr>
              ))}
              {leads.filter(l => l.status === 'Lost').length === 0 && <tr><td colSpan={5}><Empty icon="₹₹₹" msg="No lost leads ₹ great work!" /></td></tr>}
            </tbody>
          </table>
        </Card>
      </div>
    </>
  );

  return (
    <>
      <TopBar title={meta.title} subtitle="Sales & CRM" alertCount={0} action={<Btn onClick={() => setShowModal(true)}>+ New Lead</Btn>} />
      <div style={{ padding: '24px 28px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 13, marginBottom: 20 }}>
          <Stat label="Total Leads" value={filtered.length} icon="₹₹₹" iconBg={C.purpleBg} iconColor={C.purple} valueColor={C.purple} />
          <Stat label="Hot Leads" value={hotCount} icon="₹₹₹" iconBg={C.redBg} iconColor={C.red} valueColor={hotCount > 0 ? C.red : C.text} />
          <Stat label="Converted" value={converted} icon="₹₹" valueColor={C.accent} />
          <Stat label="Pipeline Value" value={inr(total)} icon="₹₹" valueColor={C.accent} />
        </div>
        <Card>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr><Th c="Lead Name" /><Th c="Source" /><Th c="Type" /><Th c="Phone" /><Th c="Value" /><Th c="Status" /><Th c="Follow-up" /></tr></thead>
              <tbody>
                {filtered.length === 0 ? <tr><td colSpan={7}><Empty icon="₹₹₹" msg="No leads in this category" /></td></tr> :
                  filtered.map(l => (
                    <tr key={l.id} className="row-h">
                      <Td><span style={{ fontWeight: 600 }}>{l.name}</span></Td>
                      <Td><Chip>{l.source}</Chip></Td>
                      <Td style={{ color: C.text3 }}>{l.type}</Td>
                      <Td style={{ color: C.text3, fontFamily: 'monospace', fontSize: 12 }}>{l.phone}</Td>
                      <Td><span style={{ fontWeight: 600 }}>{inr(l.value)}</span></Td>
                      <Td><SBadge s={l.status} /></Td>
                      <Td style={{ color: l.followup === todayStr() ? C.red : C.text3, fontSize: 12 }}>{l.followup} {l.followup === todayStr() && '₹₹'}</Td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
      {showModal && (
        <Modal title="New Lead" onClose={() => setShowModal(false)}>
          <Inp label="Lead Name / Company" value={form.name} onChange={f('name')} placeholder="e.g. Kapoor Family" />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Inp label="Source" value={form.source} onChange={f('source')} opts={['Instagram','Facebook','Website','WhatsApp','OTA','Phone','Referral','Corporate','Email']} />
            <Inp label="Lead Type" value={form.type} onChange={f('type')} opts={['Wedding','Corporate Outing','Room Stay','Day Excursion','School Picnic','MICE Event','Restaurant']} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Inp label="Phone" value={form.phone} onChange={f('phone')} placeholder="9820001234" />
            <Inp label="Estimated Value (₹₹)" value={form.value} onChange={f('value')} type="number" placeholder="250000" />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Inp label="Status" value={form.status} onChange={f('status')} opts={['New','Warm','Hot','Cold']} />
            <Inp label="Follow-up Date" value={form.followup} onChange={f('followup')} type="date" />
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
            <Btn onClick={addLead} style={{ flex: 1, justifyContent: 'center' }}>₹₹₹ Save Lead</Btn>
            <Btn variant="ghost" onClick={() => setShowModal(false)} style={{ flex: 1, justifyContent: 'center' }}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </>
  );
}

//  GENERIC PLACEHOLDER ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
function ComingSoon({ icon, title, subtitle, bullets }) {
  return (
    <>
      <TopBar title={title} subtitle={subtitle} alertCount={0} />
      <div style={{ padding: '40px 28px' }}>
        <Card style={{ padding: '48px 40px', textAlign: 'center', maxWidth: 560, margin: '0 auto' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>{icon}</div>
          <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 22, fontWeight: 800, color: C.text, marginBottom: 8 }}>{title}</div>
          <div style={{ color: C.text3, fontSize: 14, marginBottom: 28 }}>This module is ready to be connected to your backend.</div>
          <div style={{ textAlign: 'left', background: C.bg, borderRadius: 12, padding: '18px 22px' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 12 }}>This module will include</div>
            {bullets.map((b, i) => <div key={i} style={{ fontSize: 13, color: C.text2, marginBottom: 7, display: 'flex', gap: 8 }}><span style={{ color: C.accent }}>₹₹₹</span>{b}</div>)}
          </div>
        </Card>
      </div>
    </>
  );
}

//  BOOKINGS ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
function Bookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('All');
  const [form, setForm] = useState({ booking_type: 'Room Stay', pax_count: '1', start_date: todayStr(), total_amount: '', advance_paid: '', source: 'Direct' });
  const f = (k) => (v) => setForm(p => ({ ...p, [k]: v }));
  const load = useCallback(() => { setLoading(true); api.get('/bookings').then(d => { setBookings(Array.isArray(d) ? d : []); setLoading(false); }).catch(() => setLoading(false)); }, []);
  useEffect(() => { load(); }, [load]);
  const submit = async () => { await api.post('/bookings', { ...form, booking_code: uid(form.booking_type), balance_amount: parseFloat(form.total_amount || 0) - parseFloat(form.advance_paid || 0) }); setShowModal(false); load(); };
  const changeStatus = async (id, status) => { await api.patch(`/bookings/${id}/status`, { status }); load(); };
  const statuses = ['All','Confirmed','Checked In','Completed'];
  let filtered = bookings.filter(b => [b.booking_code, b.guest_name, b.company_name, b.booking_type].join(' ').toLowerCase().includes(search.toLowerCase()));
  if (filterStatus !== 'All') filtered = filtered.filter(b => b.booking_status === filterStatus);
  const totalRev = bookings.reduce((s, b) => s + parseFloat(b.total_amount || 0), 0);
  const pending = bookings.reduce((s, b) => s + parseFloat(b.balance_amount || 0), 0);
  return (
    <>
      <TopBar title="Bookings" subtitle="All reservations ₹ rooms, events, day outings" action={<Btn onClick={() => setShowModal(true)}>+ New Booking</Btn>} alertCount={0} />
      <div style={{ padding: '24px 28px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 13, marginBottom: 20 }}>
          <Stat label="Total Bookings" value={bookings.length} icon="₹₹₹₹" iconBg={C.purpleBg} iconColor={C.purple} valueColor={C.purple} />
          <Stat label="Active" value={bookings.filter(b => b.booking_status === 'Checked In').length} icon="₹₹" valueColor={C.accent} />
          <Stat label="Revenue" value={inr(totalRev)} icon="₹₹" valueColor={C.accent} />
          <Stat label="Balance Pending" value={inr(pending)} icon="₹₹" iconBg={pending > 0 ? C.amberBg : C.accentLight} valueColor={pending > 0 ? C.amber : C.text} />
        </div>
        <Card>
          <div style={{ padding: '14px 18px', borderBottom: `1px solid ${C.border}`, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="₹₹₹  Search bookings₹" style={{ flex: 1, minWidth: 200, padding: '8px 12px', background: C.bg, border: `1px solid ${C.border2}`, borderRadius: 8, color: C.text, fontSize: 13 }} />
            {statuses.map(s => <button key={s} onClick={() => setFilterStatus(s)} style={{ padding: '6px 14px', borderRadius: 8, border: `1px solid ${filterStatus === s ? C.accent : C.border2}`, background: filterStatus === s ? C.accentLight : 'transparent', color: filterStatus === s ? C.accent : C.text3, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{s}</button>)}
          </div>
          {loading ? <Empty icon="₹₹" msg="Loading₹" /> : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr><Th c="Code" /><Th c="Guest / Group" /><Th c="Type" /><Th c="Date" /><Th c="Pax" /><Th c="Amount" /><Th c="Balance" /><Th c="Status" /><Th c="Action" /></tr></thead>
                <tbody>
                  {filtered.length === 0 ? <tr><td colSpan={9}><Empty icon="₹₹₹₹" msg="No bookings found" /></td></tr> :
                    filtered.map(b => (
                      <tr key={b.id} className="row-h">
                        <Td><span style={{ fontFamily: 'monospace', fontSize: 11, background: C.bg, padding: '2px 6px', borderRadius: 4, color: C.text3 }}>{b.booking_code}</span></Td>
                        <Td><span style={{ fontWeight: 600 }}>{b.guest_name || b.company_name || '₹'}</span></Td>
                        <Td><Chip color={C.blue} bg={C.blueBg} border={C.blueBorder}>{b.booking_type}</Chip></Td>
                        <Td style={{ color: C.text3, fontSize: 12 }}>{b.start_date?.slice(0, 10)}</Td>
                        <Td><span style={{ fontWeight: 700, color: C.accent }}>{b.pax_count}</span></Td>
                        <Td><span style={{ fontWeight: 600 }}>{inr(b.total_amount)}</span></Td>
                        <Td><span style={{ color: parseFloat(b.balance_amount) > 0 ? C.amber : C.text3 }}>{inr(b.balance_amount)}</span></Td>
                        <Td><SBadge s={b.booking_status} /></Td>
                        <Td>
                          {b.booking_status === 'Confirmed' && <Btn onClick={() => changeStatus(b.id, 'Checked In')} style={{ padding: '5px 12px', fontSize: 12 }}>Check In</Btn>}
                          {b.booking_status === 'Checked In' && <Btn variant="danger" onClick={() => changeStatus(b.id, 'Completed')} style={{ padding: '5px 12px', fontSize: 12 }}>Check Out</Btn>}
                        </Td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        </Card>
      </div>
      {showModal && (
        <Modal title="New Booking" onClose={() => setShowModal(false)}>
          <Inp label="Booking Type" value={form.booking_type} onChange={f('booking_type')} opts={['Room Stay','Corporate Day Out','Wedding','School Picnic','MICE Event','Day Excursion']} />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Inp label="Date" value={form.start_date} onChange={f('start_date')} type="date" />
            <Inp label="Pax" value={form.pax_count} onChange={f('pax_count')} type="number" />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Inp label="Total Amount (₹₹)" value={form.total_amount} onChange={f('total_amount')} type="number" />
            <Inp label="Advance Paid (₹₹)" value={form.advance_paid} onChange={f('advance_paid')} type="number" />
          </div>
          <Inp label="Source" value={form.source} onChange={f('source')} opts={['Direct','Phone','Website','OTA','Referral','Walk-in']} />
          <div style={{ padding: '13px 16px', background: C.bg, borderRadius: 9, marginBottom: 14, display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontSize: 13, color: C.text2 }}>Balance Due</span>
            <span style={{ fontSize: 15, fontWeight: 700, color: C.accent }}>{inr(parseFloat(form.total_amount || 0) - parseFloat(form.advance_paid || 0))}</span>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <Btn onClick={submit} style={{ flex: 1, justifyContent: 'center' }}>₹₹₹ Confirm Booking</Btn>
            <Btn variant="ghost" onClick={() => setShowModal(false)} style={{ flex: 1, justifyContent: 'center' }}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </>
  );
}

//  ROOMS ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
function Rooms() {
  const [rooms, setRooms] = useState([]);
  const [filter, setFilter] = useState('All');
  const load = useCallback(() => api.get('/rooms').then(d => setRooms(Array.isArray(d) ? d : [])), []);
  useEffect(() => { load(); }, [load]);
  const changeStatus = async (id, status) => { await api.patch(`/rooms/${id}/status`, { status }); load(); };
  const opts = ['Vacant Clean','Vacant Dirty','Occupied','Maintenance'];
  const filtered = filter === 'All' ? rooms : rooms.filter(r => r.status === filter);
  const counts = opts.reduce((a, s) => ({ ...a, [s]: rooms.filter(r => r.status === s).length }), {});
  return (
    <>
      <TopBar title="Rooms / PMS" subtitle={`${rooms.length} rooms ₹ ${Math.round((counts['Occupied'] || 0) / Math.max(rooms.length, 1) * 100)}% occupancy`} alertCount={0} />
      <div style={{ padding: '24px 28px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 13, marginBottom: 20 }}>
          <Stat label="Occupied" value={counts['Occupied'] || 0} icon="₹₹₹" iconBg={C.blueBg} iconColor={C.blue} valueColor={C.blue} />
          <Stat label="Vacant Clean" value={counts['Vacant Clean'] || 0} icon="₹₹" valueColor={C.accent} />
          <Stat label="Vacant Dirty" value={counts['Vacant Dirty'] || 0} icon="₹₹₹" iconBg={C.amberBg} iconColor={C.amber} valueColor={C.amber} />
          <Stat label="Maintenance" value={counts['Maintenance'] || 0} icon="₹₹₹" iconBg={C.redBg} iconColor={C.red} valueColor={C.red} />
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
          {['All', ...opts].map(s => <button key={s} onClick={() => setFilter(s)} style={{ padding: '6px 14px', borderRadius: 8, border: `1px solid ${filter === s ? C.accent : C.border2}`, background: filter === s ? C.accentLight : C.surface, color: filter === s ? C.accent : C.text3, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{s}</button>)}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
          {filtered.map(r => (
            <Card key={r.id} style={{ padding: 18 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 22, fontWeight: 800, color: C.text }}>#{r.room_number}</div>
                <SBadge s={r.status} />
              </div>
              <div style={{ fontSize: 12, color: C.text3, marginBottom: 2 }}>{r.type_name}</div>
              <div style={{ fontSize: 12, color: C.text3, marginBottom: 13 }}>Floor {r.floor} ₹ {inr(r.base_tariff)}/night</div>
              <select onChange={e => changeStatus(r.id, e.target.value)} value={r.status} style={{ width: '100%', padding: '7px 10px', background: C.bg, border: `1px solid ${C.border2}`, borderRadius: 7, color: C.text, fontSize: 12, cursor: 'pointer' }}>
                {opts.map(s => <option style={{background:'#0F2040',color:'#F0F2FF'}} key={s}>{s}</option>)}
              </select>
            </Card>
          ))}
          {filtered.length === 0 && <div style={{ gridColumn: '1/-1' }}><Empty icon="₹₹₹" msg="No rooms match" /></div>}
        </div>
      </div>
    </>
  );
}

//  EVENTS & WEDDINGS ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹
const EVENTS_SAMPLE = [
  { id: 1, name: 'Sharma Wedding Reception', type: 'Wedding', venue: 'Central Lawn', date: '2026-07-12', pax: 600, status: 'Confirmed', value: 1850000 },
  { id: 2, name: 'ABC Tech Corporate Outing', type: 'Corporate Day Out', venue: 'Jungle Amphitheatre', date: todayStr(), pax: 250, status: 'Checked In', value: 700000 },
  { id: 3, name: 'Singh 25th Anniversary', type: 'Anniversary', venue: 'Poolside Deck', date: '2026-07-15', pax: 80, status: 'Confirmed', value: 120000 },
  { id: 4, name: 'Green Valley School Picnic', type: 'School Picnic', venue: 'Jungle Amphitheatre', date: '2026-07-05', pax: 180, status: 'Confirmed', value: 171000 },
];

function Events() {
  const [events, setEvents] = useState(EVENTS_SAMPLE);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: '', type: 'Wedding', venue: 'Central Lawn', date: todayStr(), pax: '', value: '', status: 'Confirmed' });
  const f = (k) => (v) => setForm(p => ({ ...p, [k]: v }));
  const addEvent = () => { setEvents(p => [...p, { id: uid(form.type), ...form, pax: parseInt(form.pax) || 0, value: parseInt(form.value) || 0 }]); setShowModal(false); };
  return (
    <>
      <TopBar title="Events & Weddings" subtitle="Venue bookings, function sheets, event management" action={<Btn onClick={() => setShowModal(true)}>+ New Event</Btn>} alertCount={0} />
      <div style={{ padding: '24px 28px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 13, marginBottom: 20 }}>
          <Stat label="Total Events" value={events.length} icon="₹₹₹₹₹" iconBg={C.purpleBg} iconColor={C.purple} valueColor={C.purple} />
          <Stat label="Weddings" value={events.filter(e => e.type === 'Wedding').length} icon="₹₹₹₹" valueColor={C.accent} />
          <Stat label="Corporate" value={events.filter(e => e.type === 'Corporate Day Out').length} icon="₹₹₹" iconBg={C.blueBg} iconColor={C.blue} valueColor={C.blue} />
          <Stat label="Total Value" value={inr(events.reduce((s, e) => s + e.value, 0))} icon="₹₹" valueColor={C.accent} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 14 }}>
          {events.map(e => (
            <Card key={e.id} className="card-h" style={{ padding: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: C.text, marginBottom: 3 }}>{e.name}</div>
                  <div style={{ fontSize: 12, color: C.text3 }}>{e.venue}</div>
                </div>
                <SBadge s={e.status} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 12 }}>
                {[['₹₹₹₹ Date', e.date],['₹₹₹ Pax', e.pax + ' guests'],['₹₹₹ Type', e.type],['₹₹₹₹ Value', inr(e.value)]].map(([k, v]) => (
                  <div key={k} style={{ background: C.bg, borderRadius: 8, padding: '9px 12px' }}>
                    <div style={{ fontSize: 10, color: C.text3, marginBottom: 2 }}>{k}</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: C.text }}>{v}</div>
                  </div>
                ))}
              </div>
            </Card>
          ))}
        </div>
      </div>
      {showModal && (
        <Modal title="New Event Booking" onClose={() => setShowModal(false)}>
          <Inp label="Event Name" value={form.name} onChange={f('name')} placeholder="e.g. Sharma Wedding Reception" />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Inp label="Event Type" value={form.type} onChange={f('type')} opts={['Wedding','Anniversary','Corporate Day Out','School Picnic','Birthday','MICE','Conference']} />
            <Inp label="Venue" value={form.venue} onChange={f('venue')} opts={['Central Lawn','Jungle Amphitheatre','Conference Hall A','Conference Hall B','Poolside Deck','Banquet Hall']} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Inp label="Event Date" value={form.date} onChange={f('date')} type="date" />
            <Inp label="Expected Pax" value={form.pax} onChange={f('pax')} type="number" />
          </div>
          <Inp label="Total Value (₹₹)" value={form.value} onChange={f('value')} type="number" />
          <div style={{ display: 'flex', gap: 10 }}>
            <Btn onClick={addEvent} style={{ flex: 1, justifyContent: 'center' }}>₹₹₹ Confirm Event</Btn>
            <Btn variant="ghost" onClick={() => setShowModal(false)} style={{ flex: 1, justifyContent: 'center' }}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </>
  );
}

export default function App() {
 const { user, logout, loading } = useAuth()
const currentUserRole = (() => { try { return JSON.parse(localStorage.getItem('botanix_user'))?.roleKey||''; } catch { return '--'; } })();
  const defaultTab = (() => {
    const roleTabMap = {
      'SUPER_ADMIN': 'dashboard', 'Super Admin': 'dashboard',
      'ADMIN': 'dashboard', 'Admin': 'dashboard',
      'RESORT_GM': 'gm_dashboard', 'General Manager': 'gm_dashboard',
      'FRONT_OFFICE': 'front_office', 'Front Desk': 'front_office',
      'MARKETING': 'crm', 'Marketing': 'crm', 'Sales & CRM': 'crm',
      'SALES_DIRECTOR': 'my_sales', 'Sales Director': 'my_sales',
      'HORTICULTURE': 'horticulture', 'Horticulture': 'horticulture',
      'CONSTRUCTION': 'construction', 'Construction': 'construction',
      'HOUSEKEEPING': 'housekeeping', 'Housekeeping': 'housekeeping', 'Activity Manager': 'housekeeping',
      'KITCHEN': 'kitchen', 'Kitchen Chef': 'kitchen',
      'ACCOUNTS': 'accounts', 'Accounts': 'accounts', 'Reports & Analytics': 'accounts',
      'HR': 'hr', 'HR & Admin': 'hr',
      'SECURITY': 'housekeeping', 'Security': 'housekeeping',
    };
    return roleTabMap[currentUserRole] || roleTabMap[user?.role] || 'gm_dashboard';
  })();
  const [tab, setTab] = useState(defaultTab);
  
  // Redirect to correct tab when user loads/changes
  React.useEffect(() => {
    if (user && user.roleKey) {
      const roleTabMap = {
        'SUPER_ADMIN': 'dashboard', 'ADMIN': 'dashboard',
        'RESORT_GM': 'gm_dashboard',
        'FRONT_OFFICE': 'front_office',
        'MARKETING': 'crm', 'SALES_DIRECTOR': 'my_sales',
        'HORTICULTURE': 'horticulture', 'CONSTRUCTION': 'construction',
        'HOUSEKEEPING': 'housekeeping', 'KITCHEN': 'kitchen',
        'ACCOUNTS': 'accounts', 'HR': 'hr', 'SECURITY': 'housekeeping',
      };
      const correctTab = roleTabMap[user.roleKey] || 'gm_dashboard';
      setTab(correctTab);
    }
  }, [user]);
  const alertCount = SYSTEM_ALERTS.length;
  if (loading) return <div>Loading Botanix ERP₹</div>;
  if (!user) return <LoginPage />;
  injectStyles();
  const BackBtn = () => {
  const roleTabMap2 = {
    'SUPER_ADMIN':'dashboard','ADMIN':'dashboard',
    'RESORT_GM':'gm_dashboard','FRONT_OFFICE':'front_office',
    'MARKETING':'crm','SALES_DIRECTOR':'my_sales',
    'HORTICULTURE':'horticulture','CONSTRUCTION':'construction',
    'HOUSEKEEPING':'housekeeping','KITCHEN':'kitchen',
    'ACCOUNTS':'accounts','HR':'hr','SECURITY':'housekeeping',
  };
  const backTab = roleTabMap2[user?.roleKey] || roleTabMap2[currentUserRole] || 'gm_dashboard';
  return (<button onClick={()=>setTab(backTab)}
    style={{position:'fixed',bottom:24,right:24,zIndex:99,padding:'10px 20px',background:'linear-gradient(135deg,#22C55E,#16A34A)',color:'#fff',border:'none',borderRadius:12,fontSize:13,fontWeight:700,cursor:'pointer',boxShadow:'0 4px 16px rgba(34,197,94,.4)',display:'flex',alignItems:'center',gap:8}}>
    Back to Dashboard
  </button>);
}

  const render = () => {
if (tab === 'meal_forecast') return <><MealForecast /><BackBtn/></>;
    if (tab === 'bmint')          return <><BMint /><BackBtn/></>;
  if (tab === 'kitchen_ai')     return <><KitchenAI /><BackBtn/></>;
  if (tab === 'wedding_ai')     return <><WeddingAI /><BackBtn/></>;
  if (tab === 'revenue_ai')     return <><RevenueAI /><BackBtn/></>;
  if (tab === 'lead_ai')        return <><LeadAI /><BackBtn/></>;
  if (tab === 'botanix_ai') return <><BotanixAI setTab={setTab} defaultTab={defaultTab} setTab={setTab} defaultTab={defaultTab} /><BackBtn/></>;
  if (tab === 'gm_dashboard') return <GMDashboard />;
    if (tab === 'front_office') return <FrontOfficeDashboard />;
    if (tab === 'room_management') return <><RoomManagement /><BackBtn/></>;
    if (tab === 'room_pms') return <><RoomPMS /><BackBtn/></>;
if (tab === 'room_calendar') return <><RoomCalendar /><BackBtn/></>;
if (tab === 'guest_portal') return <GuestPortal />;    
if (tab === 'dashboard') { // Master delete available in settings // Master delete available in settings
    if (currentUserRole === 'SUPER_ADMIN' || currentUserRole === 'Super Admin' || currentUserRole === 'ADMIN' || currentUserRole === 'Admin') {
      return <LiveDashboard setTab={setTab} />;
    } else {
      // Redirect non-admins to their dashboard
      return <><div style={{padding:40,textAlign:'center',color:'#C83333',fontWeight:700,fontSize:16}}>Access Restricted - Redirecting...</div>{setTimeout(()=>setTab(defaultTab),1000)&&null}</>;
    }
  }
    const CRM_TABS = ['crm','crm_social','crm_website','crm_whatsapp','crm_ota','crm_corporate','crm_wedding','crm_calendar','crm_synopsis','crm_pipeline','crm_conversion','crm_lost'];
  if (CRM_TABS.includes(tab))   return <><CRMPage tab={tab} /><BackBtn/></>;
    if (tab === 'proposals')      return <><ProposalBuilder /><BackBtn/></>;
    if (tab === 'bookings')       return <><BookingEngine /><BackBtn/></>;
    if (tab === 'rooms')          return <><Rooms /><BackBtn/></>;
    if (tab === 'events')         return <><Events /><BackBtn/></>;
    if (tab === 'activities')     return <><div style={{padding:40,textAlign:'center',color:'#A0A8C0'}}>? Activities module coming soon</div><BackBtn/></>;
    if (tab === 'staff_food')      return <><StaffFood /><BackBtn/></>
    if (tab === 'housekeeping')   return <><Housekeeping /><BackBtn/></>;
    if (tab === 'inventory')      return <><Inventory /><BackBtn/></>;
  if (tab === 'vendors')        return <><VendorManagement /><BackBtn/></>;
    if (tab === 'horticulture')   return <><Horticulture /><BackBtn/></>;
if (tab === 'ipm') return <><IPMModule /><BackBtn/></>;
    if (tab === 'construction')   return <><Construction /><BackBtn/></>;
    if (tab === 'kitchen')   return <><KitchenManagement /><BackBtn/></>;
    if (tab === 'food_menu')      return <><FoodMenu /><BackBtn/></>;
    if (tab === 'accounts')       return <><Accounts /><BackBtn/></>;
  if (tab === 'invoices')       return <><InvoiceModule /><BackBtn/></>;
  if (tab === 'refunds')        return <><RefundManagement /><BackBtn/></>;
    if (tab === 'gst')     return <><GSTConfig /><BackBtn/></>;
    if (tab === 'hr')             return <><HR /><BackBtn/></>;
    if (tab === 'social_media')   return <><SocialMediaIntegration /><BackBtn/></>;
    if (tab === 'marketing')      return <><Marketing /><BackBtn/></>;
    if (tab === 'sales_dashboard') return <><SalesDashboard /><BackBtn/></>;
    if (tab === 'sales_performance') return <><SalesPerformance /><BackBtn/></>;
    if (tab === 'crm_admin')      return <><SalesCRM /><BackBtn/></>;
    if (tab === 'reports')        return <><Reports /><BackBtn/></>;
    if (tab === 'user_management')return <><UserManagement /><BackBtn/></>;
    if (tab === 'session_logs')   return <><SessionLogs /><BackBtn/></>;
    if (tab === 'property_config') return <><PropertyConfig /><BackBtn/></>;
    if (tab === 'settings')       return <><PricingManager />{(currentUserRole==='SUPER_ADMIN'||currentUserRole==='Super Admin')&&<MasterDelete/>}<BackBtn/></>;
    if (tab === 'dynamic_pricing')return <><DynamicPricing /><BackBtn/></>;
    if (tab === 'notifications')  return <><Notifications /><BackBtn/></>;
if (tab === 'print') return <><PrintModule /><BackBtn/></>;
    return <Dashboard setTab={setTab} />;
  };
  if (tab === 'botanix_ai') return <><BotanixAI setTab={setTab} defaultTab={defaultTab} /><BackBtn/></>;
  if (tab === 'gm_dashboard') return <GMDashboard />;
  if (tab === 'front_office') return <FrontOfficeDashboard />;
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: C.bg }}>
<PushNotificationManager/>
      <Sidebar tab={tab} setTab={setTab} alertCount={alertCount} user={user} logout={logout} />
      <main style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', maxHeight: '100vh', overflowY: 'auto' }}>
        {render()}
      </main>
    </div>
  );
}

